import React, { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext/ThemeContext";
import { useLanguage } from "../../../context/language/LanguageContext";
import logo from "../../../images/logo.png";
import AideaLogo from "../../../images/AideaLogo.png";

const NavHader = () => {
  const [toggle, setToggle] = useState(false);
  const { openMenuToggle } = useContext(ThemeContext);
  const { language } = useLanguage();

  // Apply dir attribute dynamically to document
  useEffect(() => {
    document.documentElement.dir = language === "ar" ? "rtl" : "ltr";
    document.body.dir = language === "ar" ? "rtl" : "ltr";
  }, [language]);

  const handleMenuToggle = () => {
    setToggle(!toggle);
    openMenuToggle();
  };

  return (
    <div
      className="nav-header"
      dir={language === "ar" ? "rtl" : "ltr"}
    >
      {/* Logo */}
      <Link to="/" className="brand-logo">
        <img src={AideaLogo} alt="Logo" />
      </Link>

      {/* Hamburger Button */}
      <div
        className="nav-control"
        onClick={handleMenuToggle}
      >
        <div className={`hamburger ${toggle ? "is-active" : ""}`}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </div>
    </div>
  );
};

export default NavHader;